import React from "react";
import { Box, Typography, useMediaQuery, useTheme, Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const heroContent = {
    title: "Terms Of Use",
    description: "Your career is a journey, not a destination. Join us for an incredible adventure!",
  };

  return (
    <>
     <link 
  rel="preload" 
  as="image" 
  href="/close-up-person-working-alternative-energy-480w.webp" 
  media="(max-width: 767px)"
  fetchpriority="high" 
/>
<link 
  rel="preload" 
  as="image" 
  href="/close-up-person-working-alternative-energy-768w.webp" 
  media="(min-width: 768px) and (max-width: 1199px)"
  fetchpriority="high" 
   type="image/webp"
/>
<link 
  rel="preload" 
  as="image" 
  href="/close-up-person-working-alternative-energy.webp" 
  media="(min-width: 1200px)"
  fetchpriority="high" 
/>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        component="section"
        sx={{
          position: "relative",
          width: "95%",
          height: isMobile ? "300px" : "500px",
          overflow: "hidden",
          backgroundColor: "#fff",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Background Image with WebP and Responsive Sizes */}
        <Box
          component="picture"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
        >
          <source
    srcSet={`
      /close-up-person-working-alternative-energy.webp,
       
    `}
    rel="preload"
    sizes="100vw"
    type="image/webp"
  />
  <source
    srcSet={`
      /close-up-person-working-alternative-energy.jpg 480w,
      /close-up-person-working-alternative-energy.jpg 768w,
      /close-up-person-working-alternative-energy.jpg 1200w,
      /close-up-person-working-alternative-energy.jpg 1920w
    `}
    rel="preload"
    sizes="100vw"
    type="image/jpg"
  />
  {/* Fallback image */}
  <Box
    component="img"
    src="/close-up-person-working-alternative-energy.webp"
    alt="women-reading-the-terms-of-use."
    sx={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
    rel="preload"
    loading="eager"
    fetchpriority="high"
    decoding="sync"
    width={isMobile ? 480 : 1200}
    height={isMobile ? 300 : 500}
  />
        </Box>

        {/* Background Overlay with Diagonal Gradient */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(135deg, rgba(0, 0, 0, 0.86) 0%, rgba(10, 10, 10, 0.48) 100%)",
            zIndex: 1,
          }}
        />

        {/* Centered Content */}
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
            textAlign: "center",
            padding: "20px",
          }}
        >
          {/* Title */}
          <Typography
            variant="h2"
            sx={{
              fontSize: isMobile ? "52px" : "72px",
              color: "#fff",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            {heroContent.title}
          </Typography>

           
          
            
        </Box>
      </Box>
    </Box></>
  );
};

export default Hero;